<script setup lang="ts">
const {locale, locales} = useI18n();
const switchLocalePath = useSwitchLocalePath();
</script>

<template>
    <div class="flex flex-row gap-2 lg:ml-8">
        <NuxtLink
            v-for="{code, name} in locales"
            :key="code"
            :to="switchLocalePath(code)"
            class="language-option rounded-[9px] py-1 px-3 font-medium"
            :class="{
    'text-white !font-bold bg-[#3D0703]': code === locale
}"
        >
            {{ name }}
        </NuxtLink>
    </div>
</template>

<style scoped>
    .language-option {
        font-family: "Quicksand", "sans-serif" !important;
    }
</style>
